import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=49f2fcea&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=ts"
export * from "./Faq.vue?vue&type=script&lang=ts"
import style0 from "./Faq.vue?vue&type=style&index=0&id=49f2fcea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f2fcea",
  null
  
)

export default component.exports